import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { STORE_STYLES } from '../../assets/data/arrays'
import type { DevolucionOrderListItem } from '../../types/devoluciones'

interface DevolucionOrderListProps {
  orders: DevolucionOrderListItem[]
  basePath: string
  isLoading: boolean
  isLoadingMore: boolean
  emptyMessage: string
  onSelectOrder: (orderId: number) => void
  lastOrderRef?: (node: HTMLDivElement | null) => void
}

function getStoreBadge(storeName?: string | null) {
  const name = (storeName ?? '').trim()
  const row = STORE_STYLES.find(
    (store) =>
      store.value === name ||
      (name === 'Barístico' && store.value === 'Baristico') ||
      (name === 'Home Center' && store.value === 'Homecenter')
  )
  if (row) {
    return { prefix: row.shortValue, className: row.color }
  }

  const parts = name.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) {
    return {
      prefix: `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase(),
      className: 'text-gray-600 font-semibold'
    }
  }
  const first = parts[0] ?? ''
  const prefix = first.length >= 2 ? first.slice(0, 2).toUpperCase() : '??'
  return { prefix, className: 'text-gray-600 font-semibold' }
}

const DevolucionOrderList: React.FC<DevolucionOrderListProps> = ({
  orders,
  basePath,
  isLoading,
  isLoadingMore,
  emptyMessage,
  onSelectOrder,
  lastOrderRef
}) => {
  const location = useLocation()

  if (isLoading) {
    return <div className="text-center text-gray-500">Cargando pedidos...</div>
  }

  if (!orders.length) {
    return <div className="text-center text-gray-500">{emptyMessage}</div>
  }

  return (
    <div className="space-y-2">
      {orders.map((order, index) => {
        const badge = getStoreBadge(order.store_name)
        const path = `${basePath}/${order.id}`
        return (
          <div
            key={order.id}
            ref={index === orders.length - 1 ? lastOrderRef : undefined}
          >
            <Link
              to={path}
              onClick={() => onSelectOrder(order.id)}
              className={`block rounded-lg p-3 text-sm transition-colors ${
                location.pathname === path
                  ? 'bg-blue-50 text-blue-700'
                  : 'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <div className="font-semibold">
                <span className={badge.className}>{badge.prefix}</span> #{order.id}
              </div>
              <div className="text-xs text-gray-500">
                {order.customer_full_name || 'Cliente sin nombre'}
              </div>
              <div className="text-xs text-gray-400">{order.date_created}</div>
            </Link>
          </div>
        )
      })}
      {isLoadingMore && (
        <div className="py-2 text-center text-gray-500">Cargando más pedidos...</div>
      )}
    </div>
  )
}

export default DevolucionOrderList
